<template lang="pug">
.supercharged-entertainment-container
  .modals(v-if="userVerificationPrompt")
    re-se-modal(v-if="userVerificationPrompt" @close="showUserVerificationPrompt(false)" container-class="v-modal-md" :no-close-button="true")
      verify-account-error(:email="user.email" :show-home-link="true")
  template(v-else)
    .my-account.page-profile(v-if="user")
      .my-account-navigation
        ul.profile-menu
          li(v-for="item in menu" :class="{ active: active(item.key) }")
            a(href="#" @click.prevent="select(item.key)" :class="{ active: active(item.key) }") {{ item.title }}
          li.profile-logout-menu(v-if="showLogout")
            a.logout(href="#" @click.prevent="logout") Sign out
      .tab-content
        component(:is="selectedComponent" v-bind="getProfileTabAttrs(selected)" :key="selected")
</template>

<script>
import {coerceBoolean} from 'utils/vue/lib/utils'

import PagesMixin from '../../components/_mixins/pages'
import ConfigMixin from '../../components/_mixins/config'
import ProfileMixin from 'utils/vue/mixins/profile'
import ProfileLocationMixin from 'utils/vue/mixins/profile/location'

import EditTab from './edit'
import GiftcardsTab from './giftcards'

import VerifyAccountError from '../../components/global/verify-account-error'
import config from '../../lib/config'
const EventBus = window.VueEventBus

const components = {
  EditTab,
  GiftcardsTab,
  VerifyAccountError,
}

const menu = [
  { key: 'edit', title: 'My Profile' },
  { key: 'giftcards', title: 'My Gift Cards' },
  { key: 'loyalty', title: 'Loyalty Rewards', component: 're-profile-loyalty' },
]

try {
  require('marketing/playcards/_mixins/playcard-list')

  components.PlaycardsTab = require('./playcards').default
  menu.splice(1, 0, { key: 'playcards', title: 'My {{PLAYCARD_TC}}s' })
} catch (e) {}

export default {
  name: 'page-profile',
  settings: 'page.profile',
  translations: 'page.profile',
  components,
  props: {
    showLogout: {
      type: [Boolean, Number, String],
      default() {
        return !!this.$options.$$s('showLogout', true)
      }
    },
  },
  mixins: [
    PagesMixin,
    ConfigMixin,
    ProfileMixin,
    ProfileLocationMixin
  ],

  data: () => ({
    selected: null,
  }),

  computed: {
    user() {
     return this.authUser
    },
    menu() {
      const menuDef = _.merge({}, this.$$t('menu') || {}, this.$$s('menu') || {})
      let menuItems = _.cloneDeep(menu)
      _.forOwn(menuDef, (item, key) => {
        const menuIndex = _.findIndex(menuItems, menuItem => menuItem.key === key)
        if (menuIndex >= 0) {
          if (!item) {
            menuItems[menuIndex] = null
          } else if (_.isObject(item)) {
            const menuItem = menuItems[menuIndex]
            menuItems[menuIndex] = _.merge({}, menuItem, item)
          }
        } else {
          if (_.isObject(item)) {
            menuItems.push(item)
          }
        }
      })
      return this.translateProductName(_.filter(menuItems), ['title'])
    },
    selectedMenu() {
      return _.find(this.menu, m => m.key === this.selected) || this.menu[0]
    },
    selectedComponent() {
      return this.selectedMenu.component || `${this.selected}-tab`
    }
  },

  created() {
    this.authGuard(this)
    EventBus.$on('user.logout', () => this.authGuard(this))

    const hash = window.location.hash.replace(/^#/, '')
    const menu = this.menu.find(x => x.key == hash) || this.menu[0]
    this.selected = menu.key

    if (this.user && !this.user.verified) {
      this.showUserVerificationPrompt(true)
    }
    this.updateProfileDataItem({'initialAutoloaded': true})
    this.updateProfileDataItem({'loading.profile': false})
  },

  methods: {
    select(item) {
      window.location.hash = item
      this.selected = item
    },
    active(item) {
      return this.selected === item
    },
    getProfileTabAttrs(name) {
      const translations = this.$$clone(this.$$t(`tab.${name}`, this.$t('this')))
      const settings = this.$$clone(this.$$s(`tab.${name}`, this.$$s()))
      const attr = {
        translations,
        settings,
      }
      return attr
    }
  },
}
</script>
<style lang="scss">
  @import '../../components/_scss/base';
</style>

